import { Box } from '@mui/material';
import type { Header } from '@tanstack/react-table';
import { filterCellBoxSx } from './filterLayoutStyles';
import CustomDropdown from '../../../../../components/common/CustomDropdown';
import type { LookupDataItem } from '../../../types';

type LookupFilterInputProps<T> = {
  header: Header<T, unknown>;
  filterValue: string;
  manualFiltering?: boolean;
  lookupMap: Record<string, string>;
  lookupItems?: LookupDataItem[];
};

/**
 * Lookup filter input component
 */
const LookupFilterInputComponent = <T,>({
  header,
  filterValue,
  lookupMap,
  manualFiltering,
  lookupItems,
}: LookupFilterInputProps<T>) => {
  'use memo';

  const lookupItemIds = new Set((lookupItems ?? []).map((item) => String(item.Id)));
  const options = [
    ...(lookupItems ?? [])
      .filter((item) => Object.prototype.hasOwnProperty.call(lookupMap, String(item.Id)))
      .map((item) => ({
        value: String(item.Id),
        label: lookupMap[String(item.Id)],
      })),
    ...Object.entries(lookupMap)
      .filter(([id]) => !lookupItemIds.has(id))
      .map(([id, label]) => ({ value: id, label })),
  ];

  return (
    <Box sx={filterCellBoxSx} className="grid-filter-lookup">
      <CustomDropdown
        options={options}
        value={filterValue || undefined}
        onChange={(val) => {
          const next = val ?? undefined;
          if (manualFiltering) {
            header.column.setFilterValue(next ? { op: '=', val: next } : undefined);
          } else {
            header.column.setFilterValue(next);
          }
        }}
        searchable
        showAllOption
        allOptionLabel="All"
      />
    </Box>
  );
};

export const LookupFilterInput = LookupFilterInputComponent;
